module.exports = __webpack_public_path__ + "img/04.2ed9ca35.png";